function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Notifcations"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93, 91, 92)",
      fillOpacity: 1
    },
    d: "M 21.6875 16.503906 C 21.6875 15.1875 20.746094 13.9375 19.027344 13 C 18.828125 12.890625 18.703125 12.695312 18.703125 12.480469 L 18.703125 8.429688 C 18.730469 1.875 10.386719 -1.648438 5.375 2.90625 C 3.84375 4.28125 2.980469 6.179688 2.988281 8.160156 L 2.988281 12.480469 C 2.984375 12.699219 2.859375 12.894531 2.65625 13 C 0.941406 13.941406 0 15.1875 0 16.503906 C 0 18.621094 2.175781 19.949219 6.457031 20.457031 C 6.757812 22.496094 8.632812 24.015625 10.84375 24.015625 C 13.058594 24.015625 14.929688 22.496094 15.234375 20.457031 C 19.515625 19.949219 21.6875 18.621094 21.6875 16.503906 Z M 10.84375 22.359375 C 9.679688 22.359375 8.652344 21.65625 8.296875 20.621094 C 9.152344 20.664062 9.980469 20.695312 10.855469 20.695312 C 11.730469 20.691406 12.542969 20.664062 13.394531 20.621094 C 13.039062 21.65625 12.011719 22.359375 10.84375 22.359375 Z M 14.304688 18.890625 C 11.28125 19.195312 2.121094 19.320312 1.777344 16.503906 C 1.777344 15.796875 2.410156 15.058594 3.554688 14.429688 C 4.300781 14.023438 4.761719 13.285156 4.765625 12.480469 L 4.765625 8.160156 C 4.769531 6.628906 5.441406 5.167969 6.621094 4.101562 C 7.800781 3.035156 9.390625 2.457031 11.035156 2.496094 C 14.382812 2.695312 16.976562 5.304688 16.925781 8.429688 L 16.925781 12.480469 C 16.925781 13.28125 17.386719 14.019531 18.128906 14.425781 C 19.277344 15.058594 19.910156 15.792969 19.910156 16.503906 C 19.910156 17.691406 17.867188 18.558594 14.304688 18.886719 Z M 14.304688 18.890625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.75,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(93, 91, 92)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 5.134789 0.38497 C 4.005395 1.045777 3.034203 1.952027 2.291527 3.032919 C 1.390648 4.425335 0.784203 5.982952 0.507348 7.62081 ",
    transform: "matrix(0.888889,0,0,0.827586,0.443556,0.43531)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.75,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(93, 91, 92)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 5.100585 0.281862 C 4.490535 0.818607 3.924404 1.402389 3.400661 2.019291 C 3.245896 2.197347 2.434144 3.25764 2.434144 3.25764 C 2.434144 3.25764 2.361574 3.356545 2.157728 3.670943 C 1.428302 4.964868 0.9151 6.368529 0.637064 7.823816 ",
    transform: "matrix(-0.389333,0.744,-0.799111,-0.362483,23.246223,3.061241)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.ab03c497402b68a6715af4eadc49ccb6.svg";
export { ForwardRef as ReactComponent };